import { render, staticRenderFns } from "./CollectionLocalization.vue?vue&type=template&id=459173c2&scoped=true&"
import script from "./CollectionLocalization.vue?vue&type=script&lang=js&"
export * from "./CollectionLocalization.vue?vue&type=script&lang=js&"
import style0 from "./CollectionLocalization.vue?vue&type=style&index=0&id=459173c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459173c2",
  null
  
)

export default component.exports